import React, { Component } from 'react';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import MatButton from '@mui/material/Button';
import AppConfig from 'Constants/AppConfig';
import { getAcceptContract } from 'Actions';

class ContractsAccept extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewdiv: true,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getAcceptContract();
  }

  onAddSession1(id){
        
  }

  render() {
    const { match, contractacceptlist, loading } = this.props;
    
    const options = {
      filterType: 'dropdown',
      rowsPerPage: 50,
      responsive:'standard',
      rowsPerPageOptions: [50, 100, 150],
      selectableRowsHideCheckboxes: true,
    };

    const columns = [
      { name: 'sno', label: 'SNO.' },
      { name: 'student', label: 'STUDENT' },
      { name: 'agreementtype', label: 'AGREEMENT TYPE' },
      { name: 'executiondate', label: 'EXECUTION DATE' },
      { name: 'startdate', label: 'AGREEMENT START DA' },
      { name: 'enddate', label: 'AGREEMENT END DATE' },
      { name: 'action', label: 'ACTION' },
    ];
    
    const tableData = contractacceptlist.map((assmntval, idx) => {
      const ebtn = (
        <a href={AppConfig.apiurl+'/ctagreementdownload?id='+assmntval.ctsaID}><MatButton variant="contained" 
      color="error" className="btn-danger mr-10 mb-10 btn-sm text-white">
           Download
        </MatButton></a>
     );
      return {
        sno: idx + 1,
        student: assmntval.studentname,
        agreementtype: assmntval.agreementtype,
        executiondate: assmntval.exdate,
        startdate: assmntval.stdate,
        enddate: assmntval.eddate,
        action: ebtn,
      };
    });

    return (
      <div className="saas-dashboard">
        {this.state.viewdiv && (
          <div className="col-sm-12 col-lg-12">
            <MUIDataTable data={tableData} columns={columns} options={options} />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { contractDashboard } = state;
  return {
    contractacceptlist: contractDashboard.contractacceptlist,
    loading: contractDashboard.loading,
  };
};

export default connect(mapStateToProps, {
    getAcceptContract,
})(ContractsAccept);
